<template>
    <transition name="fade">
        <div class="pagetop" v-show="show">
            <div v-scroll-to="'body'" class="pagetop__wrap js-pagetop">
            <svg viewBox="0 0 180 180">
                <polygon fill="#42AB9E" points="25.246,147.627 89.993,82.879 154.747,147.627 180,122.374 89.993,32.374 0,122.374 	"/>
            </svg>
            <img src="../assets/images/common/page-top_btn.svg" alt=""/></div>
        </div>
    </transition>
</template>


<script>
  export default {
    name: 'Pagetop',
    data() {
        return {
            show: false
        };
    },
    mounted() {
        // スクロール・イベントを追加
        window.addEventListener('scroll', () => {
            this.show = (window.scrollY > 200);
        });

    }
  }
</script>


<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
